import { MdDeleteOutline, MdModeEditOutline } from "react-icons/md";
import { Grid, Table } from "semantic-ui-react";

export const loadTableData = (
  unitData: any | [],
  removeDataHandler: any,
  setUnitSizeUpdate?: any,
  setDefaultType?: any
) => {
  return unitData.map((data: any, index: number) => {
    return (
      <Table.Row className="tbleR" key={index}>
        <Table.Cell>
          <p>{data?.sales_unit_name ?? ""}</p>
        </Table.Cell>
        <Table.Cell>
          <p>{data?.sales_unit_size ?? ""}</p>
        </Table.Cell>
        <Table.Cell>
          <p>{data?.sales_unit_type ?? ""}</p>
        </Table.Cell>
        <Table.Cell>
          <p>{data?.ean_barcode ?? ""}</p>
        </Table.Cell>
        <Table.Cell>
          <Grid>
            <Grid.Column computer={5} tablet={16} mobile={16}>
              <MdModeEditOutline
                cursor={"pointer"}
                size={24}
                color="var(--tableEditIcon)"
                onClick={() => {
                  setUnitSizeUpdate(data, index);
                  setDefaultType(data.sales_unit_type);
                }}
              />
            </Grid.Column>
            <Grid.Column computer={4} tablet={16} mobile={16} key={index}>
              <MdDeleteOutline
                cursor={"pointer"}
                onClick={() => removeDataHandler(data, true)}
                size={24}
                color="var(--tableEditIcon)"
              />
            </Grid.Column>
          </Grid>
        </Table.Cell>
      </Table.Row>
    );
  });
};
